/* unplugin-vue-components disabled */import { render } from "./ChoosePlatform.vue?vue&type=template&id=04230f0c&scoped=true&ts=true"
import script from "./ChoosePlatform.vue?vue&type=script&lang=ts"
export * from "./ChoosePlatform.vue?vue&type=script&lang=ts"

import "./ChoosePlatform.vue?vue&type=style&index=0&id=04230f0c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04230f0c"]])

export default __exports__